import { endOfDay, endOfMonth, format, startOfDay, startOfMonth, subDays, subMonths } from 'date-fns';
export var ANALYTICS_FILTER_PERIODS = [
    'week',
    'month',
    '3month',
    '6month',
    'year',
    'custom'
];
export function getDateRangeForFilterPeriod(period, refDate) {
    if (refDate === void 0) { refDate = new Date(); }
    var todayStart = startOfDay(refDate);
    var todayEnd = endOfDay(refDate);
    switch (period) {
        case 'week':
            return {
                dateFrom: subDays(todayStart, 6),
                dateTo: todayEnd
            };
        case 'month':
            return {
                dateFrom: startOfDay(subMonths(refDate, 1)),
                dateTo: todayEnd
            };
        case '3month':
            return {
                dateFrom: startOfDay(subMonths(refDate, 3)),
                dateTo: todayEnd
            };
        case '6month': {
            var dateTo = endOfMonth(refDate);
            return {
                dateFrom: startOfMonth(subMonths(dateTo, 5)),
                dateTo: dateTo
            };
        }
        case 'year': {
            var dateTo = endOfMonth(refDate);
            return {
                dateFrom: startOfMonth(subMonths(dateTo, 11)),
                dateTo: dateTo
            };
        }
        case 'custom':
            return {
                dateFrom: subDays(todayStart, 6),
                dateTo: todayEnd
            };
        default:
            return {
                dateFrom: subDays(todayStart, 6),
                dateTo: todayEnd
            };
    }
}
var ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
export function resolveAnalyticsPeriodDates(input, refDate) {
    var _a;
    if (refDate === void 0) { refDate = new Date(); }
    var period = input.period;
    var dateFrom;
    var dateTo;
    if (period === 'custom') {
        var customDateFrom = input.customDateFrom;
        var customDateTo = input.customDateTo;
        if (!customDateFrom || !customDateTo) {
            return {
                error: 'For period "custom", provide customDateFrom and customDateTo (YYYY-MM-DD).'
            };
        }
        if (!ISO_DATE_RE.test(customDateFrom) || !ISO_DATE_RE.test(customDateTo)) {
            return { error: 'customDateFrom and customDateTo must be YYYY-MM-DD' };
        }
        dateFrom = startOfDay(new Date(customDateFrom));
        dateTo = endOfDay(new Date(customDateTo));
        if (dateFrom > dateTo) {
            return { error: 'customDateFrom must be on or before customDateTo' };
        }
    }
    else {
        (_a = getDateRangeForFilterPeriod(period, refDate), dateFrom = _a.dateFrom, dateTo = _a.dateTo);
    }
    var dateFromStr = format(dateFrom, 'yyyy-MM-dd');
    var dateToStr = format(dateTo, 'yyyy-MM-dd');
    return {
        period: period,
        dateFrom: dateFromStr,
        dateTo: dateToStr
    };
}
